export default {
	props:{
		name: String,
		value:  [ String, Number],
		options: [Object, Array],
		extLabel: String, //work as label
		label: String, //work as placeholder
		labelValue: {
			type:[Object, String, Number],
			default:'',
		},
		labelDisabled:{
			type:Boolean,
			default:false,
		},
		labelSelected:{
			type:Boolean,
			default:true,
		},
		clearable: Boolean,
		disabled: Boolean,
		errorMsg: String,
	},
	data(){
		return {
			innerValue: typeof(this.value)!=='undefined'&&this.value!==null ? this.value : this.labelValue,
			hintVisible: true,
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(){ this.innerValue = typeof(this.value)!=='undefined'&&this.value!==null ? this.value : this.labelValue; },
		},
	},
	computed:{
		cpSelectedOption(){
			let opt = null;
			for(const i in this.options){
				if(this.options[i].value===this.innerValue){
					opt = this.options[i];
					break;
				}
			}
			return opt;
		},
		cpActiveClear(){
			return this.clearable && this.innerValue!==this.labelValue;
		}
	},
	methods: {
		onChange(){
			let opt = this.cpSelectedOption;
			if(opt && opt.href){
				window.location.href = opt.href;
				return;
			}
			this.$emit('input', this.innerValue);
			this.$emit('change', this.innerValue);
			this.$emit('change-option', opt);
		},
		onClear(){
			if(this.cpActiveClear){
				this.innerValue = this.labelValue;
				this.onChange();
				this.$emit('clear');
			}
		},
		setInnerValue(val){
			this.innerValue = val;
		}
	},
	template: `
<div :class="{'styled-select':true, 'clearable':clearable}">
	<label v-if="extLabel" class="ext-label" :for="name">{{extLabel}}</label>
	<select @change="onChange" v-model="innerValue" :id="name" :name="name" :disabled="disabled">
		<option v-if="label" :value="labelValue" :disabled="labelDisabled" :selected="labelSelected">{{label}}</option>
		<option v-for="(option,index) in options" :value="option.value" :disabled="option.disabled">{{option.label}}</option>
	</select>
	<span v-if="hintVisible && errorMsg" class="hint error-msg" v-t="errorMsg"></span>
	<span v-if="clearable" :class="['qicon-1 clear-icon', this.cpActiveClear?'active':'in-active']" @click="onClear">trash</span>
</div>
`,
}
